import Axios from "axios";
import moment from "../../../../../../../../plugins/moment";
import phonePrefixes from "./phonePrefixes";
import { countries } from "./countries.ts";
import { mapGetters } from "vuex";
import { NIGHTS_GET_IS_PACK_FLIGHT } from "../../../../../../../../store/nights/getter-types";

const today = new Date();
const daysByMonth = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

export default {
  props: {
    refId: {
      type: String,
      required: true,
      default: () => undefined
    },
    formProp: {
      type: Object,
      default: () => {
        return null;
      }
    },
    documentNeeded: {
      type: Boolean,
      default: true
    }
  },
  data() {
    const { onlyShowPassportOption } = this.$store.state;

    return {
      nationalities: countries,
      form: {
        valid: false,
        gender: {
          label: this.$t("form.gender"),
          value: 'mr'
        },
        firstName: {
          label: this.$t("form.name") + "*",
          value: null,
          rules: [v => !!v || this.$t("form.enter_name")]
        },
        lastName: {
          label: this.$t("form.last_name") + "*",
          value: null,
          rules: [v => !!v || this.$t("form.enter_last_name")]
        },
        email: {
          label: this.$t("form.email") + "*",
          value: null,
          rules: [
            v => !!v || this.$t("form.enter_email"),
            v => /.+@.+/.test(v) || this.$t("form.invalid_email")
          ]
        },
        birthday: {
          label: this.$t("form.date_of_birth") + "*",
          day: {
            value: 1,
            rules: [v => !!v || this.$t("form.choose_a_day")]
          },
          month: {
            value: 1,
            items: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].reduce(
              this.paddedDates,
              []
            ),
            rules: [v => !!v || this.$t("form.choose_a_month")]
          },
          year: {
            value: today.getFullYear(),
            items: window._.range(today.getFullYear(), 1899),
            rules: [v => !!v || this.$t("form.choose_a_year")]
          }
        },
        nationality: {
          label: this.$t("form.nationality") + "*",
          value: this.$t("form.spanish_nationality"),
          rules: [v => !!v || this.$t("form.enter_nationality")]
        },
        idCard: {
          label: this.$t("form.id_document") + "*",
          label_passport:this.$t("form.passport") + "*",
          type: {
            value: onlyShowPassportOption ? "NIF" : "DNI",
            items: [
              ...(onlyShowPassportOption ? [] : [{
                text: "DNI",
                value: "DNI"
              }]),
              {
                text: this.$t("form.passport"),
                value: "NIF"
              }
            ],
            rules: [v => !!v || this.$t("form.choose_a_document")]
          },
          number: {
            value: null,
            rules: [v => !!v || this.$t("form.enter_document")]
          }
        },
        expiration_date:{
          label: this.$t("form.document_expiration_date") + "*",
          label_passport: this.$t("form.document_expiration_date_passport") + "*",
          day: {
            value: 1,
            rules: [v => !!v || this.$t("form.choose_a_day")]
          },
          month: {
            value: 1,
            items: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].reduce(this.paddedDates,[]),
            rules: [v => !!v || this.$t("form.choose_a_month")]
          },
          year: {
            value: 1,
            items: window._.range(today.getFullYear(), today.getFullYear()+30),
            rules: [v => !!v || this.$t("form.choose_a_year")]
          }
        },
        phone: {
          label: this.$t("form.phone") + "*",
          countryCode: {
            value: "+34 (ES)",
            items: phonePrefixes.map(
              country => `${country.dial_code} (${country.code})`
            ),
            rules: [v => !!v || this.$t("form.choose_a_country_code")]
          },
          number: {
            value: null,
            rules: [
              v => !!v || this.$t("form.enter_phone"),
              v => /^\d+$/.test(v) || this.$t("form.enter_only_digits")
            ]
          }
        }
      }
    };
  },
  methods: {
    validate() {

      if(this.form.expiration_date.day.value && this.form.expiration_date.month.value && this.form.expiration_date.year.value && this.showAllInfo){
        const expirationDate = new Date(this.form.expiration_date.year.value, this.form.expiration_date.month.value - 1, this.form.expiration_date.day.value, 12, 0, 0);
        const today = new Date();
        if(expirationDate < today){
          this.$toastr.e(this.$t('form.invalid_expiration_date'));
          return false;
        }
      }

      return this.$refs[this.refId].validate();
    },
    checkDayExists() {
      if (
        !this.monthDays.find(day => day.value === this.form.birthday.day.value)
      ) {
        this.form.birthday.day.value = this.monthDays.slice(-1)[0].value;
      }
    },
    checkExpirationDayExists() {
      if (
        !this.expirationDateMonthDays.find(day => day.value === this.form.expiration_date.day.value)
      ) {
        this.form.expiration_date.day.value = this.expirationDateMonthDays.slice(-1)[0].value;
      }
    },
    paddedDates(prev, curr) {
      return [...prev, { text: `${curr}`.padStart(2, "0"), value: curr }];
    }
  },
  computed: {
    ...mapGetters({
      isPackFlight: NIGHTS_GET_IS_PACK_FLIGHT
    }),
    monthDays() {
      let daysInMonth = daysByMonth[this.form.birthday.month.value - 1];
      if (daysInMonth === 28 && this.form.birthday.year.value % 4 === 0) {
        daysInMonth++;
      }
      return window._.range(1, daysInMonth + 1).reduce(this.paddedDates, []);
    },
    expirationDateMonthDays() {
      let daysInMonth = daysByMonth[this.form.expiration_date.month.value - 1];
      if (daysInMonth === 28 && this.form.expiration_date.year.value % 4 === 0) {
        daysInMonth++;
      }
      if(!this.form.expiration_date.month.value) return window._.range(1, 31).reduce(this.paddedDates, []);
      return window._.range(1, daysInMonth + 1).reduce(this.paddedDates, []);
    },
    showAllInfo() {
      return this.$route.name == "reserve-area-form" || this.documentNeeded || this.$route.name == "checkout";
    },
  },
  watch: {
    form: {
      handler(form) {
        this.$emit('input', form);
      },
      deep: true,
    }
  },
  created() {
    //If we are in fill info passengers
    if (this.formProp) {
      const birthday = this.formProp.date_of_birth ? moment(this.formProp.date_of_birth) : null;
      const expiration_date = this.formProp.expiration_date ? moment(this.formProp.expiration_date) : null;

      this.form.firstName.value = this.formProp.name;
      this.form.lastName.value = this.formProp.last_name;
      this.form.email.value = this.formProp.email;
      this.form.phone.number.value = this.formProp.phone;
      this.form.phone.countryCode.value =
        this.formProp.phone_prefix || "+34 (ES)";
      this.form.birthday.year.value = birthday ? parseInt(birthday.format("YYYY")) : today.getFullYear();
      this.form.birthday.month.value = birthday ? parseInt(birthday.format("M")) : 1;
      this.form.birthday.day.value = birthday ? parseInt(birthday.format("D")) : 1;
      this.form.gender.value = this.formProp.gender;
      this.form.nationality.value = this.formProp.nationality;
      this.form.idCard.type.value = this.formProp.card_id_type || (this.$store.state.onlyShowPassportOption ? "NIF" : "DNI");
      this.form.idCard.number.value = this.formProp.card_id;
      this.form.expiration_date.day.value = expiration_date ? parseInt(expiration_date.format("D")) : null;
      this.form.expiration_date.month.value = expiration_date ? parseInt( expiration_date.format("M") ) : null;
      this.form.expiration_date.year.value = expiration_date ? parseInt( expiration_date.format("YYYY")) : null;
    }

  }
};
